import { createContext } from 'react'

export type Theme = 'light' | 'dark'

export interface ThemeContextType {
  theme: Theme
  toggleTheme: () => void
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

/**
 * The colour of the browser's own chrome for each theme, written to theme-color.
 *
 * These are the NAVBAR's colours (bg-white / dark:bg-gray-900), because the navbar
 * is what sits against the top of the screen.
 *
 * They are deliberately NOT the canvas colours. The canvas follows the FOOTER,
 * whose tone alternates per route, so on a grey-footer page the canvas is gray-50
 * or gray-800 while these stay white or gray-900. See components/CanvasTone and
 * the canvas rules in src/index.css. Keying this pair to the footer instead was
 * tried and put an ashy tint above a navy header on half the site.
 */
export const CHROME_COLOUR: Record<Theme, string> = {
  light: '#ffffff',
  dark: '#111827',
}

export const THEME_STORAGE_KEY = 'demirix-theme'
